import { ca } from '@cian/analytics';

export function trackVideoBlockShow() {
  ca('eventSite', {
    action: 'show',
    label: 'Video',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
